import { apiGuestClient } from "@/lib/api/guestClient";
import { apiPaths } from "@/lib/api/paths";
import type { AuthResponse } from "./types";

interface SignInWithPasswordParams {
  email: string;
  password: string;
}

export const signInWithPassword = async (
  params: SignInWithPasswordParams,
): Promise<AuthResponse> => {
  const response = await apiGuestClient.post<AuthResponse>(
    apiPaths.auth.login,
    params,
  );
  return response.data;
};
